/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Select_Target_Folder_AriaInputs */

const en_drastic_tech_select_target_folder_aria = /** @type {(inputs: Drastic_Tech_Select_Target_Folder_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Target Folder`)
};

const fr_drastic_tech_select_target_folder_aria = /** @type {(inputs: Drastic_Tech_Select_Target_Folder_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner le dossier cible`)
};

const de_drastic_tech_select_target_folder_aria = /** @type {(inputs: Drastic_Tech_Select_Target_Folder_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielordner auswählen`)
};

const it_drastic_tech_select_target_folder_aria = /** @type {(inputs: Drastic_Tech_Select_Target_Folder_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona cartella di destinazione`)
};

const ru_drastic_tech_select_target_folder_aria = /** @type {(inputs: Drastic_Tech_Select_Target_Folder_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите целевую папку`)
};

const es_drastic_tech_select_target_folder_aria = /** @type {(inputs: Drastic_Tech_Select_Target_Folder_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar carpeta de destino`)
};

const zh_cn2_drastic_tech_select_target_folder_aria = /** @type {(inputs: Drastic_Tech_Select_Target_Folder_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择目标文件夹`)
};

const ja_drastic_tech_select_target_folder_aria = /** @type {(inputs: Drastic_Tech_Select_Target_Folder_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲットフォルダを選択`)
};

const hi_drastic_tech_select_target_folder_aria = /** @type {(inputs: Drastic_Tech_Select_Target_Folder_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य फ़ोल्डर का चयन करें`)
};

const pt_pt2_drastic_tech_select_target_folder_aria = /** @type {(inputs: Drastic_Tech_Select_Target_Folder_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a pasta de destino`)
};

/**
* | output |
* | --- |
* | "Select Target Folder" |
*
* @param {Drastic_Tech_Select_Target_Folder_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_select_target_folder_aria = /** @type {((inputs?: Drastic_Tech_Select_Target_Folder_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Select_Target_Folder_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_select_target_folder_aria(inputs)
	if (locale === "de") return de_drastic_tech_select_target_folder_aria(inputs)
	if (locale === "it") return it_drastic_tech_select_target_folder_aria(inputs)
	if (locale === "ru") return ru_drastic_tech_select_target_folder_aria(inputs)
	if (locale === "es") return es_drastic_tech_select_target_folder_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_select_target_folder_aria(inputs)
	if (locale === "ja") return ja_drastic_tech_select_target_folder_aria(inputs)
	if (locale === "hi") return hi_drastic_tech_select_target_folder_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_select_target_folder_aria(inputs)
	return en_drastic_tech_select_target_folder_aria(inputs)
});